import React from 'react';
import { createUseStyles, useTheme, Styles } from 'react-jss';
import { Theme } from '@app/theme';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { CompletionVisualiser } from './CompletionVisualiser';
import { GenericButton } from '@app/core';

const useStyles = createUseStyles<string, {}, any>((theme: Theme) => ({
  container: {
    background: theme.colors.white,
    width: '100%',
    padding: theme.marginBase * 2,
    borderRadius: theme.borderRadius.large,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.marginBase * 2,
    transition: 'all .3s',
    transform: 'translateX(0px)',
  },
  leftContainer: {
    display: 'flex',
    justifyContent: 'left',
    alignItems: 'center',
    gap: theme.marginBase,
  },
  rightContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    gap: theme.marginBase,
  },
  icon: {
    color: theme.colors.inkTertiary,
    fontSize: theme.iconSize.large,
  },
  name: {
    ...theme.fonts.label,
  },
  recapCardOpen: {
    transform: `translateX(${theme.marginBase * 4}px)`,
  },
}));

type Props = {
  title: string;
  icon: string;
  isOpen?: boolean;
  completion?: number;
} & (
  | {
      to: string;
    }
  | {
      onClick: () => any;
    }
  | {
      href: string;
      onClick?: () => any;
      target?: string;
      rel?: string;
    }
);

export const RecapCard = ({
  title,
  icon,
  isOpen,
  completion,
  ...rest
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();
  return (
    <GenericButton
      className={classnames(classes.container, {
        [classes.recapCardOpen]: isOpen,
      })}
      {...rest}
    >
      <div className={classes.leftContainer}>
        <i className={classnames(icon, classes.icon)} />
        <h1 className={classes.name}>{title}</h1>
      </div>
      <div className={classes.rightContainer}>
        {completion !== undefined && (
          <CompletionVisualiser completion={completion} />
        )}
        <i className={classnames('ri-arrow-right-line', classes.icon)} />
      </div>
    </GenericButton>
  );
};
